import { FC, ReactElement } from 'react';
import { Link, LinkProps } from '@chakra-ui/react';
export interface CbNavigationLogoProps extends LinkProps {
  element?: ReactElement;
}
export const CbNavigationLogo: FC<CbNavigationLogoProps> = ({
  as,
  color,
  href,
  element,
  onClick,
  ...props
}) => {
  return <Link href={href} paddingY={3} color={color} _hover={{
    textDecoration: 'none'
  }} _focus={{
    textDecoration: 'none'
  }} onClick={onClick} as={as} {...props} data-sentry-element="Link" data-sentry-component="CbNavigationLogo" data-sentry-source-file="CbNavigationLogo.tsx">
      {element}
    </Link>;
};